/** Height of the visible staff toolbar; absent outside spoof mode. */
export const SPOOF_TOOLBAR_HEIGHT_CSS_VARIABLE = '--spoof-toolbar-height'
